import React, { forwardRef, KeyboardEvent, Ref } from 'react';
import { Input } from '@/components/ui/input';

interface Props {
  className?: string;
  placeholder?: string;
  searchTerm?: string;
  onChangeSearchTerm: (term: string) => void;
  onEnter?: () => void;
}

const SearchBox = forwardRef((props: Props, ref: Ref<HTMLInputElement>) => {
  const { className = '', placeholder = 'Enter search term (e.g. "rebase")' } =
    props;
  const change = (event: React.ChangeEvent<HTMLInputElement>) =>
    props.onChangeSearchTerm(event.target.value);

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (props.onEnter) {
        props.onEnter();
      }
    }
  };

  return (
    <Input
      className={`searchbox ${className}`}
      ref={ref}
      type="text"
      placeholder={placeholder}
      value={props.searchTerm || ''}
      onChange={change}
      onKeyDown={onKeyDown}
      autoFocus
    />
  );
});

SearchBox.displayName = 'SearchBox';

export default SearchBox;
